import { GlobeLanguage } from "@assets";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useLanguage } from "../../../lang/useLanguage";

export const SelectLanguage = (): JSX.Element => {
    const { language, setLanguage } = useLanguage();

    const [locale, setCurrentLocale] = useState(language?.toLocaleUpperCase());

    const handleToggleLocale = (localeToSet: "en" | "es"): void => {
        setLanguage?.(localeToSet);
        setCurrentLocale(localeToSet.toLocaleUpperCase());
    };

    return (
        <div className="dropdown is-hoverable">
            <div className="dropdown-trigger">
                <button
                    className="button has-text-white"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu2"
                    style={{ backgroundColor: "transparent", borderColor: "transparent" }}
                >
                    <GlobeLanguage />
                    <span className="mx-2">{locale}</span>
                    <FontAwesomeIcon icon={faAngleDown} size={"sm"} />
                </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu2" role="menu">
                <div className="dropdown-content" style={{ maxWidth: "4rem", textAlign: "center", marginLeft: "15%" }}>
                    <a
                        onClick={() => {
                            handleToggleLocale("en");
                        }}
                        className="dropdown-item"
                    >
                        EN
                    </a>
                    <a
                        onClick={() => {
                            handleToggleLocale("es");
                        }}
                        className="dropdown-item"
                    >
                        ES
                    </a>
                </div>
            </div>
        </div>
    );
};
